import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover, Tag } from "antd";
import classNames from "classnames";
import { useScanOrderCartons, ScanOrderCartonsRef } from "./helper";
import { forwardRef, useImperativeHandle } from "react";
import { LoadingMask } from "@/components/shared/LoadingSection";

interface CartonListProps {
  orderId: string;
  className?: string;
}

const CartonList = forwardRef<ScanOrderCartonsRef, CartonListProps>(
  (props, ref) => {
    const { orderId } = props;
    const { data: cartons, refetch, isFetching } = useScanOrderCartons(orderId);
    useImperativeHandle(ref, () => ({
      refresh: refetch,
    }));
    return (
      <div className="relative h-full w-full">
        {isFetching ? (
          <LoadingMask info="Loading cartons..." />
        ) : (
          <div className="flex flex-wrap flex-row gap-2 absolute w-full">
            {cartons?.map((carton) => (
              <div
                key={carton.id}
                className={classNames(
                  "flex flex-col border-b",
                  "border-gray-200 border-[1px]",
                  "rounded-md py-2 px-4 bg-white",
                )}
              >
                <div className="flex flex-rpw gap-1">
                  <span
                    title={carton.productName}
                    className={classNames(
                      "w-[150px]",
                      "overflow-hidden text-ellipsis whitespace-nowrap",
                    )}
                  >
                    {carton.productName}
                  </span>
                  <Popover content={carton.productName} trigger="hover">
                    <InfoCircleOutlined />
                  </Popover>
                </div>
                <div>
                  <div className="flex flex-row items-center gap-1">
                    <span className="text-[12px] text-gray-500">
                      {carton.productNo}
                    </span>
                  </div>
                  <div className="flex flex-row items-center gap-1 mt-[-4px]">
                    <span className="text-[12px] text-gray-500">
                      {carton.productBarcode}
                    </span>
                  </div>
                  {carton.extra?.scanSerialNo && (
                    <div className="flex flex-row items-center gap-1">
                      <Tag color="red" className="!text-[9px] !h-[16px] !flex !items-center !justify-center">
                        Need Serial No.
                      </Tag>
                    </div>
                  )}
                </div>
                <div className="flex flex-row items-center justify-between mt-[-4px]">
                  <div>Scan / Total:</div>
                  <div className="flex flex-row items-center">
                    <span>{carton.scanned}</span>
                    <span className="text-gray-500 px-2">/</span>
                    <span>{carton.cartons}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  },
);

CartonList.displayName = "CartonList";

export default CartonList;
